module.exports = __webpack_public_path__ + "components/country-flag/static/id-066b9d9e490f68c92db2271d81323824.svg";